<template>
  <div :class="$vuetify.breakpoint.mdAndDown ? 'pt-0 pb-4' : 'py-4'">
    <v-row class="py-6" no-gutters>
      <!--        <v-col cols="12" class="bg-ambas d-flex pa-0">-->
      <v-col cols="12" :class="$vuetify.breakpoint.lgOnly ? 'tabHeight' : ''" class="pa-0 bg-ambas" v-if="isImageLoaded && showAmbasBanner" :style="{ backgroundImage: 'url(' + currentBackgroundImage + ')' }">
        <v-col cols="12" class="col-md-7 ambas">
          <v-img :src="`${mediaUrl}/banner/bhg_mobile.png`" class="hidden-md-and-up banner-img" style="height: 100%; width: 100%;"></v-img>
          <div class="carousel-controls">
            <button v-for="(image, index) in images" :key="index" @click="selectImage(index)" :class="{ active: index === currentIndexes }" class="control-dot"></button>
          </div>
        </v-col>
        <v-col cols="12" class="align-center col-md-5  ambas-vid">
          <div class="iframe-box">
            <iframe
              :src="currentVideoSource"
              width="100%"
              height="100%"
              style="border: none; overflow: hidden; border-radius: 10px; aspect-ratio: 16/9"
              scrolling="no"
              frameborder="0"
              allowfullscreen="false"
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            ></iframe>
          </div>
        </v-col>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import stingFormat from 'string-format'
import { formValidator, uiHelper } from '@/util'
import { SHARED } from '@/constants/constants'
import { GAME_MATCHES_HIGHLIGHTS } from '@/store/game.module'
import { ROUTE_NAME } from '@/constants/route.constants'
import { locale } from '@/util/localization-helper'
export default {
  name: 'appHomeHighlight',
  data: () => ({
    highlights: null,
    routeName: ROUTE_NAME,
    mediaUrl: SHARED.MEDIA_SERVER_URL,
    isImageLoaded: false,
    currentIndexes: 0,
    images: [
      {
        src: SHARED.MEDIA_SERVER_URL + '/banner/bhg_mobile.png',
        background: SHARED.MEDIA_SERVER_URL + '/banner/bhg_desktop.png',
        videoSource: 'https://www.youtube.com/embed/n8Pl_CRCa1Y?si=WUNSIMCHal_y-Esa&rel=0'
      }
    ]
  }),
  mounted() {
    this.startImageRotation()
  },
  created() {
    this.getMatchesHighlights()
  },
  computed: {
    matchesHighlights() {
      let k = this.$store.state.game.matchesHighlights
      return _.take(k, 6)
    },
    currentImage() {
      return this.images[this.currentIndexes].src
    },
    currentBackgroundImage() {
      return this.images[this.currentIndexes].background
    },
    currentVideoSource() {
      return this.images[this.currentIndexes].videoSource
    },
    showAmbasBanner() {
      const expiryDate = new Date('2025-12-30T23:59:59')
      const now = new Date()
      return now <= expiryDate
    }
  },
  watch: {},
  methods: {
    selectImage(index) {
      this.currentIndexes = index
    },
    startImageRotation() {
      this.isImageLoaded = true
      setInterval(() => {
        if (this.images.length > 0) {
          this.currentIndexes = (this.currentIndexes + 1) % this.images.length
        }
        if (this.currentIndexes >= this.images.length) {
          this.currentIndexes = 0 // Reset currentIndex to 0 if it exceeds the length of images array
        }
      }, 50000)
    },
    changeLanguage(language) {
      this.$store.dispatch(`${SHARED.LOADING}`)
      uiHelper.removeCookie('language')
      uiHelper.setCookie('language', language)
      window.location.reload()
    },
    getMatchesHighlights() {
      this.$store.dispatch(`${GAME_MATCHES_HIGHLIGHTS}`)
    }
  }
}
</script>

<style lang="scss">
// .v-card {
//     border-radius: 5px 0 0 5px !important;
// }

.highlights-container {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  max-width: 100vw;
  .border-top-left-radius {
    border-top-left-radius: 10px !important;
  }
  .border-top-right-radius {
    border-top-right-radius: 10px !important;
  }
  .border-bottom-left-radius {
    border-bottom-left-radius: 10px !important;
  }
  .border-bottom-right-radius {
    border-bottom-right-radius: 10px !important;
  }
}
.matches-box {
  margin-bottom: 5px;
  .match-item {
    display: inline-block;
    width: 360px; // padding-right: 20px;
    margin: 0 15px 0 0;
  }
  .mobile-match-card {
    &.v-card {
      text-overflow: ellipsis;
      overflow: hidden;
      width: auto;
      white-space: nowrap;
      background-color: #1d1d1d;
      border-radius: 15px;
      color: #ffffff;
    }
  }
  .mobile-detail-wrapper {
    background-color: #333333;
    height: 100px;
    .mobile-match-details {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .team-title {
      white-space: break-spaces;
      overflow: hidden;
      padding: 0 5px 0 5px;
      text-align: center;
    }
    .match-date {
      white-space: pre-line;
      text-overflow: ellipsis;
      text-align: center;
      align-items: unset;
      color: var(--v-newMobilePrimary-base);
    }
  }
}
@media (max-width: 599px) {
  .highlights-container {
    font-size: 14px;
  }

  .matches-box {
    .match-item {
      width: 285px;
    }
  }
}

.cricket-name-header {
  text-overflow: ellipsis;
  overflow: hidden;
  width: auto;
  white-space: nowrap;
}
</style>
